import React from 'react';
import { Shield, Heart, CheckCircle2, Zap } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function HeroSection() {
  const scrollToPrice = () => {
    document.getElementById('price-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full min-h-[90vh] flex flex-col items-center justify-start overflow-hidden bg-creme pt-12 pb-24 px-6" data-id="element-56">
      <div className="w-full max-w-5xl mx-auto flex flex-col items-center" data-id="element-57">
        {/* Image Content */}
        <FadeIn delay={0.1} fullWidth data-id="element-58">
          <div className="w-full max-w-4xl mx-auto mb-12" data-id="element-59">
            <img src="https://cdn.magicpatterns.com/uploads/jfJhvJujV2gXhun7HAxKQU/promts_landing_bullying.png" alt="Madre consolando a su hijo" className="w-full h-auto object-cover object-center rounded-3xl shadow-soft" data-id="element-60" />
          </div>
        </FadeIn>

        {/* Text Content */}
        <div className="w-full max-w-3xl flex flex-col items-center text-center" data-id="element-61">
          <FadeIn delay={0.2} data-id="element-62">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-beige text-soft-brown text-sm font-medium mb-8" data-id="element-63">
              <Shield className="w-4 h-4 text-warm-accent" data-id="element-64" />
              <span className="tracking-wide" data-id="element-65">
                Protocolo Anti-Acoso Escolar
              </span>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-66">
            <h1 className="font-cormorant font-semibold text-5xl md:text-6xl lg:text-7xl leading-[1.1] text-dark-coffee mb-8" data-id="element-67">
              Tu hijo no te cuenta todo…{' '}
              <span className="italic font-bold text-warm-accent block mt-2" data-id="element-68">
                pero el bullying ya empezó.
              </span>
            </h1>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-69">
            <p className="text-lg md:text-xl text-soft-brown mb-10 leading-relaxed max-w-2xl font-sans font-light" data-id="element-70">
              Este protocolo te muestra cómo detectarlo, frenarlo y protegerlo
              en menos de 24 horas — sin depender del colegio.
            </p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-71">
            <div className="flex flex-col items-center w-full" data-id="element-72">
              <div className="flex items-center gap-2 mb-4 text-sm font-medium text-soft-brown/80" data-id="element-73">
                <CheckCircle2 className="w-4 h-4 text-green-600" data-id="element-74" />
                <span data-id="element-75">Más de 1.000 padres ya aplicaron este método</span>
              </div>

              <button onClick={scrollToPrice} className="w-full sm:w-auto bg-warm-accent hover:bg-[#8A4525] text-white font-bold py-5 px-10 rounded-full transition-all duration-300 animate-pulse-glow flex items-center justify-center gap-3 text-lg tracking-wide shadow-xl mb-4" data-id="element-76">
                QUIERO PROTEGER A MI HIJO AHORA
              </button>

              <div className="flex items-center gap-1.5 text-sm font-medium text-warm-accent" data-id="element-77">
                <Zap className="w-4 h-4" data-id="element-78" />
                <span data-id="element-79">Acceso inmediato hoy</span>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}